var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChevronUpTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.54513L3.83312 11L2.5 9.72744L8.5 4L14.5 9.72744L13.1669 11L8.5 6.54513Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronUpTable);
export default __webpack_public_path__ + "static/media/ic_chevron_up_table.64d0513a92f526e20ee7174d02a41da9.svg";
export { ForwardRef as ReactComponent };